





























import { Component, Prop, Vue } from 'vue-property-decorator';
import { Button, Tooltip } from 'element-ui';

@Component({
  components: {
    'el-button': Button,
    'el-tooltip': Tooltip
  }
})
export default class Banner extends Vue {
  @Prop({ default: false, type: Boolean }) closable!: boolean;
  // material icon name
  @Prop({ type: String }) icon!: string;
  @Prop({ default: 'bottom', type: String }) position!: 'bottom' | 'top';
}
